module.exports = __webpack_public_path__ + "static/media/NotoSans-Bold.e83048a8.woff";